<template>
  <van-popup
    v-model:show="innerShow"
    position="right"
    :style="{ width: '100%', height: '100%' }"
  >
    <div class="i-part__content">
      <van-nav-bar
        title="查看日志"
        left-text="返回"
        left-arrow
        @click-left="
          readonly = false;
          innerShow = false;
        "
      />
      <div class="i-part__body">
        <van-steps direction="vertical" :active="0">
          <van-step v-for="item in data" :key="item.data">
            <h5>{{ item.log_note }}</h5>
            <p>{{ item.create_time_name }}</p>
          </van-step>
        </van-steps>
      </div>
    </div>
  </van-popup>
</template>
<script>
import { useVModel } from "@vueuse/core";
export default {
  nam: "Log",
  props: {
    data: {
      type: Array,
    },
    show: {
      type: Boolean,
      requried: true,
    },
  },
  setup(props, { emit }) {
    return {
      innerShow: useVModel(props, "show", emit),
    };
  },
};
</script>
<style lang="less" scoped>
.i-part__content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.i-part__body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
